<script setup>
/** 运营修改一个公会的积分、每周目标和每月预算上限（/admin/guilds/:id/edit）。 */
import { onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { Button, Card, Input } from '@drama/ui'

import { api } from '../api.js'

const { t } = useI18n()
const route = useRoute()
const guild = ref(null)
const form = reactive({ amount: '', note: '', goal: '', monthlyLimit: '', key: crypto.randomUUID() })
const message = ref('')
const error = ref('')

async function load() {
  guild.value = (await api('GET', '/api/voko/admin/guilds')).guilds.find((item) => item.id === route.params.id)
  if (guild.value === undefined) throw new Error(t('adminGuilds.notFound'))
  Object.assign(form, { goal: String(guild.value.weekly_goal), monthlyLimit: guild.value.monthly_budget_limit === null ? '' : String(guild.value.monthly_budget_limit) })
}

/**
 * @param {() => Promise<unknown>} action
 * @param {string} done
 */
async function run(action, done) {
  message.value = ''
  error.value = ''
  try {
    await action()
    await load()
    message.value = done
  } catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
  }
}

const grant = () => run(async () => {
  await api('POST', `/api/voko/admin/guilds/${guild.value.id}/budget`, { amount: Number(form.amount), note: form.note }, form.key)
  Object.assign(form, { amount: '', note: '', key: crypto.randomUUID() })
}, t('adminGuilds.saved'))
const saveGoal = () => run(() => api('PUT', `/api/voko/admin/guilds/${guild.value.id}/weekly-goal`, { weekly_goal: Number(form.goal) }), t('adminGuilds.saved'))
const saveMonthlyLimit = () => run(() => api('PUT', `/api/voko/admin/guilds/${guild.value.id}/monthly-budget-limit`, { monthly_budget_limit: form.monthlyLimit === '' ? null : Number(form.monthlyLimit) }), t('adminGuilds.saved'))

onMounted(() => run(async () => {}, ''))
</script>

<template>
  <header class="page-head">
    <div>
      <p class="page-head__eyebrow">{{ t('shell.admin') }}</p>
      <h1 class="page-head__title">{{ t('adminGuilds.edit') }}{{ guild === null ? '' : ` · ${guild.name}` }}</h1>
    </div>
    <router-link :to="`/admin/guilds/${route.params.id}`">{{ t('guildBoard.back') }}</router-link>
  </header>
  <p v-if="message" role="status">{{ message }}</p>
  <p v-if="error" role="alert">{{ error }}</p>
  <Card v-if="guild !== null" class="voko-form">
    <p>{{ t('adminGuilds.bank', guild.budget) }}</p>
    <label class="voko-field">{{ t('adminGuilds.amount') }}<Input v-model="form.amount" type="number" /></label>
    <label class="voko-field">{{ t('adminGuilds.note') }}<Input v-model="form.note" /></label>
    <Button :disabled="form.amount === '' || form.note.trim() === ''" @click="grant">{{ t('adminGuilds.grant') }}</Button>
    <label class="voko-field">{{ t('adminGuilds.goal') }}<Input v-model="form.goal" type="number" /></label>
    <Button variant="secondary" @click="saveGoal">{{ t('adminGuilds.saveGoal') }}</Button>
    <p>{{ t('adminGuilds.monthlyUsed', { points: guild.monthly_budget_used }) }}</p>
    <label class="voko-field">{{ t('adminGuilds.monthlyLimit') }}<Input v-model="form.monthlyLimit" type="number" min="0" :placeholder="t('adminGuilds.unlimited')" /></label>
    <Button variant="secondary" @click="saveMonthlyLimit">{{ t('adminGuilds.saveMonthlyLimit') }}</Button>
  </Card>
</template>

<style scoped>
.voko-form { display: grid; gap: var(--drama-space-md); }
</style>
